import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageContainer, ExportButton, TableComponents, FilterPod } from 'components';
import { Box, Grid } from '@mui/material';
import { enifyDateTime } from 'utility';
import { useExportFile } from 'hooks';
import { toFilterVOS } from 'components/FilterPod';
import { columns } from './component/columns';
import DialogServiceCall from '../MyServiceCall/components/DialogServiceCall';
import ServiceCallServices from './services/ServiceCallServices';
import InitFilters from './constants/InitFiltering';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';
import {getExport1460Url} from 'URLs';
import { useCurrencyUnit } from 'hooks';

const ServiceCall = () => {
  // -- STATES --//
  const currencyText = useCurrencyUnit();
  const [filters, setFilters] = useState(InitFilters(currencyText));
  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentServiceSetId, setCurrentServiceSetId] = React.useState(null);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'requestCallPage',
      'exportRequestCallBtn'
    ])
  // -- HOOKS --//
  const { downloadFile, isExporting } = useExportFile({
    url: getExport1460Url(),
    filename: 'service-calls',
  });
  const navigate = useNavigate();
  const tableRef = useRef();

  // -- API REQUESTS --//
  const getServiceCallQuery = async (query) => {
    const filter = toFilterVOS(filters);
    let orderBy = [];
    setLoading(true)
    if (query?.orderBy) {
      const desc = query.orderDirection === 'desc';

      switch (query.orderBy.title) {
        case 'تاریخ و زمان فراخوانی':
          orderBy = [
            { name: 'تاریخ فراخوانی', desc },
            { name: 'زمان فراخوانی', desc },
          ];
          break;
        case `قیمت (${currencyText})`:
          orderBy = [{ name: 'قیمت', desc }];
          break;
        default:
          orderBy = [{ name: query?.orderBy?.title, desc }];
          break;
      }
    }

    const params = {
      page: query ? query?.pageNumber : page,
      size: query?.pageSize || size,
    };

    const postBodyParams = {
      filterVOS: filter ?? [],
      orderByElementVOS: orderBy ?? [],
      parentParams: [
        { key: 'businessid', value: '774' },
        {
          key: 'START_DATE',
          value: enifyDateTime(filters[0]?.value?.start?.format('jYYYYjMMjDD')),
        },
        {
          key: 'END_DATE',
          value: enifyDateTime(filters[0]?.value?.end?.format('jYYYYjMMjDD')),
        },
      ],
    };

    setFilterParams({ postBodyParams, params });

    try {
      const res = await ServiceCallServices.reportServiceCall(params, postBodyParams);
      const data = res.data.result.rows.map((row, key) => ({
        // num: query?.page * query?.pageSize + key + 1,
        serviceId: row.cols[6],
        serviceName: row.cols[0],
        dateTimeCalling: `${row.cols[1]} ${row.cols[2]}`,
        callResult: row.cols[3] === 'false' ? 'ناموفق' : 'موفق',
        serviceProdvider: row.cols[4],
        price: row.cols[5] || '-',
        factorId: row.cols[7] || '-',
      }));
      setLoading(false)

      return {
        data,
        page: query ? query?.pageNumber : page,
        totalCount: res.data.result.totalCount,
      };
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const onExport = (type) => {
    downloadFile(type, filterParams?.postBodyParams, filterParams?.params);
  };

  const handleOpenDialog = (serviceSetId) => {
    setCurrentServiceSetId(serviceSetId);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };


  const hint = 'در این صفحه می‌توانید گزارش سرویس‌هایی که فراخوانی کرده‌اید را مشاهده نمایید.';

  return (
    <>
      <PageContainer
        title="لیست فراخوانی سرویس‌ها"
        breadcrumbs={constBreadCrumbsTitle.SERVICES_SERVICECALLS}
        pageKey="serviceCalls"
        description={hint}
      >
        <Grid item xs={12}>
          <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
            {actionsList['requestCallPage'] && (
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            )}
            {actionsList['exportRequestCallBtn'] && (
              <ExportButton
                loading={isExporting}
                types={['xls', 'csv']}
                onExport={onExport}
              />
            )}
          </Box>
          {actionsList['requestCallPage'] && (
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          )}
        </Grid>
        {actionsList['requestCallPage'] && currencyText && (
          <TableComponents
            data={getServiceCallQuery}
            columns={columns(handleOpenDialog, navigate , currencyText)}
            isLoading={loading}
            ref={tableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getServiceCallQuery(ps)
            }}
          />
        )}
        <DialogServiceCall
          open={openDialog}
          onClose={handleCloseDialog}
          serviceSetId={currentServiceSetId}
        />
      </PageContainer>
    </>
  );
};

export default ServiceCall;
